import React from 'react';
import { NavbarBrand, Row, Col } from 'reactstrap';
import SelectByPlatform from '../../../workplace/common/selectByPlatform';
import GiveIndia from '../../elements/icons/giveIndia';
import PartnerLogo from "../../../workplace/common/partnerLogo";
import getConfig from 'next/config';
import TrustedNgosIcon from '../../elements/icons/trustedNGOsIcon';
import SecurePaymentsIcon from '../../elements/icons/securePaymentsIcon';
import LongTermImpactIcon from '../../elements/icons/longTermImpactIcon';
import RegularReportIcon from '../../elements/icons/regularReportsIcon';

const config = getConfig().publicRuntimeConfig;

export default class CheckoutHeader extends React.Component {

	render() {
		const { logo, theme } = this.props;
		return (
			<Col md={12} className="d-flex px-0 checkout-header">
				<NavbarBrand href="/">
					<SelectByPlatform>
						<GiveIndia name={"www"} width="125" color={!logo || logo === '' || logo === 'color' ? '' : logo} />

						<PartnerLogo name={"wg"} w="100%" className={"partner-logo"} />

					</SelectByPlatform>
				</NavbarBrand>

				<div className="checkout-header-items hide-for-mobile">
					<Row>
						<Col xs="auto d-flex">
							<SecurePaymentsIcon theme={theme} size={35}/>
							{/* <img className="secure-payment-logo" src={`${config.cdnUrl}/static/images/checkout/secure+payment.svg`} alt="Secure Payment" /> */}
							<span style={{ marginLeft: '0.5rem', alignSelf: 'center' }}>Secure Payment</span>
						</Col>
						<Col xs="auto d-flex">
							<TrustedNgosIcon theme={theme} size={35}/>
							<span style={{ marginLeft: '0.5rem', alignSelf: 'center' }}>Trusted NGOs</span>
						</Col>
						<Col xs="auto d-flex">
							<LongTermImpactIcon theme={theme} size={35}/>
							<span style={{ marginLeft: '0.5rem', alignSelf: 'center' }}>Long Term Impact</span>
						</Col>
						<Col xs="auto d-flex">
							<RegularReportIcon theme={theme} size={35}/>
							<span style={{ marginLeft: '0.5rem', alignSelf: 'center' }}>Regular Reports</span>
						</Col>
					</Row>
				</div>

				<style global jsx>
					{
						`
						.checkout-header {
							border-bottom: 1px solid #dddddd;
							min-height: 70px;
							align-items: center;
						}

						.checkout-header-items img {
							height: 24px;
							padding-right: 10px;
						}

						.checkout-header-items img.secure-payment-logo {
							margin-top: -8px;
						}
						`
					}
				</style>
			</Col>
		);
	}
}

